import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@punto/frontend-shared/i18n/i18n";
import "@punto/ui/components/fonts";
import "@punto/ui/globals.css";

import { App } from "./app.tsx";
import { initSentry } from "./lib/sentry";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
